import routerOptions0 from "/builds/macys/polaris/nuxt-app/post-purchase/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/macys/polaris/nuxt-app/post-purchase/app/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}